export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11148.c93ed039.jpg";